import TK from "./tk";

export default class StatisticsHelper {

  static track_click_recharge(from) {
    TK.track_click_recharge(from)
  }


  static track_click_room_more(from) {
    TK.track_click_room_more(from)
  }

  static track_click_game_btm(from) {
    TK.track_click_game_btm(from)
  }

  static track_click_game_banner(from, name) {
    TK.track_click_game_banner(from, name)
  }

  static track_click_fast_gift(from) {
    TK.track_click_fast_gift(from)
  }

  static track_click_barrage_send(from) {
    TK.track_click_barrage_send(from)
  }

  static track_click_audience_list(from) {
    TK.track_click_audience_list(from)
  }
  static track_click_host_list(from) {
    TK.track_click_host_list(from)
  }

  static track_click_activity_msg() {
    TK.track_click_activity_msg()
  }

  static track_click_quota(from){
    TK.track_click_quota(from)
  }

  static track_click_banner(from,name){
    TK.track_click_banner(from,name)
  }

  static track_enter_pure_mode(from){
    TK.track_enter_pure_mode(from)
  }

  static track_click_boss(fromTop = false, enough = true) {
    TK.track_click_boss({
      from: fromTop ? 'window' : 'bottom',
      coins_remaining: enough ? 'enough' : 'short',
    })
  }

  static track_click_announcement(){
    TK.track_click_announcement()
  }

  static track_confirm_boss(micCameraStatus) {
    let type = 'both_on'
    switch (micCameraStatus) {
      case 1:
        type = 'only_microphone_on';
        break
      case 2:
        type = 'only_camera_on';
        break
      case 3:
        type = 'both_on';
        break
      case 4:
        type = 'nothingon';
        break
    }
    TK.track_confirm_boss({
      boss_type: type
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/StatisticsUtils.js